var map = {
	"./cancel.svg": 82514,
	"./huge-a.svg": 7955,
	"./huge-add-image.svg": 42099,
	"./huge-add-pen.svg": 73013,
	"./huge-add-user.svg": 99693,
	"./huge-ai-file.svg": 27603,
	"./huge-ai.svg": 55088,
	"./huge-archive.svg": 90968,
	"./huge-arrow-down.svg": 77930,
	"./huge-arrow-up-down.svg": 61366,
	"./huge-bmp.svg": 44063,
	"./huge-book.svg": 38709,
	"./huge-branch.svg": 76134,
	"./huge-business-case.svg": 87441,
	"./huge-car.svg": 78924,
	"./huge-check-mark.svg": 67640,
	"./huge-check.svg": 71806,
	"./huge-chevron-left.svg": 52939,
	"./huge-chevron-right.svg": 80270,
	"./huge-clients.svg": 46594,
	"./huge-close-eye.svg": 99298,
	"./huge-close.svg": 99642,
	"./huge-config.svg": 65196,
	"./huge-copy.svg": 65725,
	"./huge-danger.svg": 40107,
	"./huge-database.svg": 47037,
	"./huge-directory.svg": 5755,
	"./huge-doc.svg": 28780,
	"./huge-docs.svg": 86759,
	"./huge-document-info.svg": 72130,
	"./huge-document-link.svg": 12426,
	"./huge-document-list.svg": 53470,
	"./huge-document-star.svg": 68898,
	"./huge-docx.svg": 85148,
	"./huge-down.svg": 84342,
	"./huge-download.svg": 67246,
	"./huge-earth.svg": 94370,
	"./huge-edit.svg": 90858,
	"./huge-editor-align-center.svg": 95813,
	"./huge-editor-align-left.svg": 64269,
	"./huge-editor-align-right.svg": 76528,
	"./huge-editor-bold.svg": 12375,
	"./huge-editor-bulleted-list.svg": 73878,
	"./huge-editor-code.svg": 34501,
	"./huge-editor-heading.svg": 55716,
	"./huge-editor-italic.svg": 65978,
	"./huge-editor-link.svg": 56942,
	"./huge-editor-magic-wand.svg": 11502,
	"./huge-editor-numbered-list.svg": 97815,
	"./huge-editor-preview.svg": 13714,
	"./huge-editor-strikethrough.svg": 10211,
	"./huge-editor-table.svg": 52234,
	"./huge-editor-text.svg": 94859,
	"./huge-editor-underline.svg": 2794,
	"./huge-export-attachment.svg": 66110,
	"./huge-export.svg": 61280,
	"./huge-eye.svg": 21697,
	"./huge-file-attach.svg": 32354,
	"./huge-filter.svg": 4956,
	"./huge-flag.svg": 3260,
	"./huge-heading.svg": 50060,
	"./huge-history.svg": 81054,
	"./huge-house.svg": 14958,
	"./huge-import.svg": 25005,
	"./huge-info.svg": 4182,
	"./huge-inheritance.svg": 24286,
	"./huge-inscription.svg": 90460,
	"./huge-journal.svg": 59391,
	"./huge-jpeg.svg": 70336,
	"./huge-jpg.svg": 29703,
	"./huge-key.svg": 16547,
	"./huge-list-check.svg": 16601,
	"./huge-list.svg": 27066,
	"./huge-message-box.svg": 92895,
	"./huge-message.svg": 33507,
	"./huge-more.svg": 86793,
	"./huge-note.svg": 89258,
	"./huge-open-eye.svg": 79094,
	"./huge-organization.svg": 32783,
	"./huge-pdf.svg": 30000,
	"./huge-pen2.svg": 67503,
	"./huge-people.svg": 9307,
	"./huge-phone.svg": 29982,
	"./huge-pin.svg": 34515,
	"./huge-plus.svg": 17778,
	"./huge-png.svg": 58647,
	"./huge-print.svg": 88655,
	"./huge-puzzle.svg": 18746,
	"./huge-redo.svg": 61622,
	"./huge-reestr.svg": 26411,
	"./huge-search-file.svg": 36801,
	"./huge-search-house.svg": 66169,
	"./huge-settings.svg": 95861,
	"./huge-shevron-down.svg": 33196,
	"./huge-shevron-right.svg": 94526,
	"./huge-tariff.svg": 8292,
	"./huge-text-config.svg": 33142,
	"./huge-txt.svg": 16682,
	"./huge-undo.svg": 18224,
	"./huge-unlock.svg": 83882,
	"./huge-up.svg": 28653,
	"./huge-upload.svg": 79269,
	"./huge-user-plus.svg": 45288,
	"./huge-user-star.svg": 76184,
	"./huge-user.svg": 97663,
	"./huge-users.svg": 24926,
	"./huge-warning.svg": 14954,
	"./huge-x.svg": 11946,
	"./huge-xls.svg": 99645,
	"./huge-xlsx.svg": 57135,
	"./qr-code.svg": 43409,
	"./rounded-border.svg": 30674,
	"./sli-arrow-right-up.svg": 70479,
	"./sli-arrow-right.svg": 44655,
	"./sli-bell.svg": 71772,
	"./sli-calendar.svg": 74841,
	"./sli-calls.svg": 16814,
	"./sli-camera.svg": 28182,
	"./sli-case.svg": 97007,
	"./sli-chart.svg": 9109,
	"./sli-check-circle.svg": 15950,
	"./sli-clients.svg": 54377,
	"./sli-clipboard.svg": 42503,
	"./sli-close.svg": 85645,
	"./sli-close2.svg": 60293,
	"./sli-danger.svg": 47558,
	"./sli-disk.svg": 73832,
	"./sli-down.svg": 8091,
	"./sli-education.svg": 61171,
	"./sli-empty-bookmark.svg": 88707,
	"./sli-face-id.svg": 44766,
	"./sli-home.svg": 27982,
	"./sli-identification.svg": 96133,
	"./sli-inbox.svg": 43197,
	"./sli-info.svg": 50819,
	"./sli-interns.svg": 44802,
	"./sli-journal.svg": 29772,
	"./sli-legacy.svg": 17278,
	"./sli-letter.svg": 4235,
	"./sli-link.svg": 85823,
	"./sli-list-check.svg": 25032,
	"./sli-list.svg": 73751,
	"./sli-logout.svg": 88757,
	"./sli-main.svg": 18196,
	"./sli-medal.svg": 57632,
	"./sli-microphone.svg": 59175,
	"./sli-notif.svg": 32043,
	"./sli-pen.svg": 90596,
	"./sli-performs.svg": 87149,
	"./sli-reestr.svg": 46486,
	"./sli-refresh.svg": 72576,
	"./sli-requests.svg": 70077,
	"./sli-right.svg": 36131,
	"./sli-search-drawer.svg": 49903,
	"./sli-search.svg": 10983,
	"./sli-selected.svg": 2048,
	"./sli-send.svg": 7457,
	"./sli-services.svg": 21251,
	"./sli-settings.svg": 77276,
	"./sli-shevron-left.svg": 33870,
	"./sli-sidebar.svg": 25753,
	"./sli-static.svg": 49925,
	"./sli-system.svg": 18768,
	"./sli-wallet.svg": 95824,
	"./success.svg": 53421,
	"./tt-align-center.svg": 67950,
	"./tt-align-justify.svg": 23339,
	"./tt-align-left.svg": 16242,
	"./tt-align-right.svg": 72425,
	"./tt-align.svg": 81736,
	"./tt-blockquote.svg": 59256,
	"./tt-bold.svg": 22148,
	"./tt-code.svg": 1590,
	"./tt-hard-break.svg": 97236,
	"./tt-heading.svg": 7605,
	"./tt-horizontal-rule.svg": 15988,
	"./tt-italic.svg": 64517,
	"./tt-link.svg": 31669,
	"./tt-list-numbered.svg": 81882,
	"./tt-list.svg": 28105,
	"./tt-redo.svg": 66725,
	"./tt-strike.svg": 28019,
	"./tt-table.svg": 23807,
	"./tt-underline.svg": 159,
	"./tt-undo.svg": 4727,
	"./warning.svg": 70216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;